import { Box, Radio, Text } from '@quintoandar-tokko/jopijs';
import React, { useLayoutEffect, useRef } from 'react';
import styles from './radioButtonsGroup.module.scss';

function RadioButtonItem({ item, onClickRadio }) {
  const textRef = useRef(null);

  useLayoutEffect(() => {
    const el = textRef.current;
    const button = el?.closest('button');

    if (!el || !button) {
      return undefined;
    }

    const check = () => {
      const isTruncated = el.scrollWidth > el.clientWidth;
      button.classList.toggle(styles.hasEllipsis, isTruncated);
    };

    check();

    const ro = new ResizeObserver(check);
    ro.observe(el);

    return () => ro.disconnect();
  }, [item.text]);

  return (
    <Box
      as="button"
      className={styles.radioButton}
      onClick={() => onClickRadio(item)}
      data-checked={item.checked}
      type="button"
    >
      <Radio checked={item.checked} readOnly />
      <Box ref={textRef} className={styles.radioButtonText}>
        {item.text}
      </Box>
      <Text className={styles.radioButtonTooltip}>{item.text}</Text>
    </Box>
  );
}

export default RadioButtonItem;
